// @ts-check
let idCount = 0;

/**
 * Returns an incremented integer every time it's used
 */
export default function useIncrementingId() {
  // eslint-disable-next-line no-plusplus
  return () => ++idCount;
}
